<template>
    <div class="contain">
        <div class="box ">
            <div class="left">
                <div class="nav xy-between">
                    <div class="jf">
                        <div
                            class="font-size16 cursor back"
                            @click="backRouter"
                        >
                            <i class="el-icon-back font-size18 "></i>
                            返回
                        </div>
                        <div class="throw"></div>
                        <div
                            class="tit font-size16 font-weight"
                            v-html="passColumName"
                        ></div>
                    </div>

                    <div class="topicNum">
                        <span class="font-size24 c-256CF4">{{
                                currentOrder + 1
                            }}</span
                        >/
                        <span class="font-size16 c-868EA1">{{
                                allTopicNum
                            }}</span
                        >题
                    </div>
                </div>
                <!-- 做题 -->
                <div class="twoBox">
                    <div class="topicContain" v-if="orginObj">
                        <div class="topicNav ">
                            <div class="tit ">
                                <div class="font-size14 topicType c-256CF4">
                                    [{{
                                        orginObj.SubjectType === 1
                                            ? "单选题"
                                            : orginObj.SubjectType === 2
                                                ? "多选题"
                                                : orginObj.SubjectType === 3
                                                    ? "填空题"
                                                    : orginObj.SubjectType === 4
                                                        ? "判断题"
                                                        : orginObj.SubjectType === 5
                                                            ? "问答题"
                                                            : orginObj.SubjectType === 6
                                                                ? "复合题"
                                                                : ""
                                    }}]
                                </div>
                                <div
                                    class="font-size18 topicContent"
                                    v-if="orginObj.SubjectName"
                                    v-html="orginObj.SubjectName"
                                ></div>
                            </div>
                            <div @click="collection">

                                <i
                                    v-if="!parseInt(orginObj.collect)"
                                    class="iconfont icon-shoucang font-size24 c-E5E8EC"
                                ></i>

                                <i
                                    v-else
                                    class="iconfont icon-shoucang font-size24 c-FFD251"
                                ></i>
                            </div>
                        </div>
                        <div class="allTopics">
                            <!-- 单选题 -->
                            <div
                                class="sigleSelect "
                                v-if="orginObj.SubjectType === 1"
                            >
                                <div class="topics">
                                    <div
                                        class="topicItem jf cursor"
                                        v-for="(singleItem,
                                        index) in orginObj.AnswerList"
                                        :key="index"
                                        @click="
                                            selectSingleAnswer(
                                                singleItem,
                                                orginObj.AnswerList
                                            )
                                        "
                                    >
                                        <div
                                            class="options xy-center cursor multiple "
                                            :class="{
                                                singleActive:
                                                    singleItem.rankStyle,
                                                makeRightStyle:
                                                    singleItem.origlRight,
                                                isErrorActive:
                                                    singleItem.userIsErrStyle
                                            }"
                                        >
                                            <div>
                                                <div
                                                    v-if="
                                                        singleItem.RankNum === 1
                                                    "
                                                    class=""
                                                >
                                                    A
                                                </div>
                                                <div
                                                    v-else-if="
                                                        singleItem.RankNum === 2
                                                    "
                                                    class=""
                                                >
                                                    B
                                                </div>
                                                <div
                                                    v-else-if="
                                                        singleItem.RankNum === 3
                                                    "
                                                    class=""
                                                >
                                                    C
                                                </div>
                                                <div
                                                    v-else-if="
                                                        singleItem.RankNum === 4
                                                    "
                                                    class=""
                                                >
                                                    D
                                                </div>
                                                <div
                                                    v-else-if="
                                                        singleItem.RankNum === 5
                                                    "
                                                    class=""
                                                >
                                                    E
                                                </div>
                                                <div
                                                    v-else-if="
                                                        singleItem.RankNum === 6
                                                    "
                                                    class=""
                                                >
                                                    F
                                                </div>
                                                <div v-else class="">G</div>
                                            </div>
                                        </div>
                                        <div v-html="singleItem.Content"></div>
                                    </div>
                                </div>
                                <div>
                                    <div
                                        v-if="orginObj.status"
                                        class="parsingBox"
                                    >
                                        <div class="showAnswerText xy-between">
                                            <div class="lfet jf">
                                                <div class="right jf">
                                                    正确答案：
                                                    <div
                                                        class="c-00B37C font-size18"
                                                        v-for="(singleItem,
                                                        index) in orginObj.AnswerList"
                                                        :key="index"
                                                    >
                                                        <div
                                                            class=""
                                                            v-if="
                                                                singleItem.IsRight &&
                                                                    singleItem.RankNum ===
                                                                        1
                                                            "
                                                        >
                                                            <div>A</div>
                                                        </div>
                                                        <div
                                                            class=""
                                                            v-else-if="
                                                                singleItem.IsRight &&
                                                                    singleItem.RankNum ===
                                                                        2
                                                            "
                                                        >
                                                            <div>B</div>
                                                        </div>
                                                        <div
                                                            class=""
                                                            v-else-if="
                                                                singleItem.IsRight &&
                                                                    singleItem.RankNum ===
                                                                        3
                                                            "
                                                        >
                                                            <div>C</div>
                                                        </div>
                                                        <div
                                                            class=""
                                                            v-else-if="
                                                                singleItem.IsRight &&
                                                                    singleItem.RankNum ===
                                                                        4
                                                            "
                                                        >
                                                            <div>D</div>
                                                        </div>
                                                        <div
                                                            class=""
                                                            v-else-if="
                                                                singleItem.IsRight &&
                                                                    singleItem.RankNum ===
                                                                        5
                                                            "
                                                        >
                                                            <div>E</div>
                                                        </div>
                                                        <div
                                                            class=""
                                                            v-else-if="
                                                                singleItem.IsRight &&
                                                                    singleItem.RankNum ===
                                                                        6
                                                            "
                                                        >
                                                            <div>F</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="your jf">
                                                    您的答案：
                                                    <div
                                                        class="c-F33737 font-size18"
                                                    >
                                                        {{
                                                            this.orginObj
                                                                .SubjectAnswer
                                                                ? joinStr(
                                                                    this
                                                                        .orginObj
                                                                        .SubjectAnswer
                                                                )
                                                                : ""
                                                        }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="right">
                                                <!-- 纠错 -->
                                            </div>
                                        </div>
                                        <div class="parsing">
                                            <div class="tit jf">
                                                <div class="cyc"></div>
                                                <div class="text c-72777F">
                                                    解析
                                                </div>
                                            </div>
                                            <div>
                                                <div
                                                    class="text"
                                                    v-if="orginObj.Analysis"
                                                    v-html="orginObj.Analysis"
                                                ></div>
                                                <div v-else class="text">
                                                    暂无解析
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else class="notParsingBox"></div>
                                </div>
                            </div>
                            <!-- 多选题 -->
                            <div
                                class="multiSelect "
                                v-else-if="orginObj.SubjectType === 2"
                            >
                                <div class="topics">
                                    <div
                                        class="topicItem jf cursor"
                                        v-for="singleItem in orginObj.AnswerList"
                                        :key="singleItem.AnswerId"
                                        @click="
                                            selectSomeAnswer(
                                                singleItem,
                                                orginObj.AnswerList
                                            )
                                        "
                                    >
                                        <div
                                            class="options xy-center cursor multiple "
                                            :class="{
                                                singleActive:
                                                    singleItem.rankStyle,
                                                makeRightStyle:
                                                    singleItem.origlRight,
                                                isErrorActive:
                                                    singleItem.userIsErrStyle
                                            }"
                                        >
                                            <div>
                                                <div
                                                    v-if="
                                                        singleItem.RankNum === 1
                                                    "
                                                    class=""
                                                >
                                                    A
                                                </div>
                                                <div
                                                    v-else-if="
                                                        singleItem.RankNum === 2
                                                    "
                                                    class=""
                                                >
                                                    B
                                                </div>
                                                <div
                                                    v-else-if="
                                                        singleItem.RankNum === 3
                                                    "
                                                    class=""
                                                >
                                                    C
                                                </div>
                                                <div
                                                    v-else-if="
                                                        singleItem.RankNum === 4
                                                    "
                                                    class=""
                                                >
                                                    D
                                                </div>
                                                <div
                                                    v-else-if="
                                                        singleItem.RankNum === 5
                                                    "
                                                    class=""
                                                >
                                                    E
                                                </div>
                                                <div
                                                    v-else-if="
                                                        singleItem.RankNum === 6
                                                    "
                                                    class=""
                                                >
                                                    F
                                                </div>
                                                <div v-else class="">G</div>
                                            </div>
                                        </div>
                                        <div v-html="singleItem.Content"></div>
                                        <!-- </div> -->
                                    </div>
                                </div>
                                <div>
                                    <div
                                        v-if="orginObj.status"
                                        class="parsingBox"
                                    >
                                        <div class="showAnswerText xy-between">
                                            <div class="lfet jf">
                                                <div class="right jf">
                                                    正确答案：
                                                    <div
                                                        class="c-00B37C font-size18"
                                                        v-for="(singleItem,
                                                        index) in orginObj.AnswerList"
                                                        :key="index"
                                                    >
                                                        <div
                                                            class=""
                                                            v-if="
                                                                singleItem.IsRight &&
                                                                    singleItem.RankNum ===
                                                                        1
                                                            "
                                                        >
                                                            <div>A</div>
                                                        </div>
                                                        <div
                                                            class=""
                                                            v-else-if="
                                                                singleItem.IsRight &&
                                                                    singleItem.RankNum ===
                                                                        2
                                                            "
                                                        >
                                                            <div>B</div>
                                                        </div>
                                                        <div
                                                            class=""
                                                            v-else-if="
                                                                singleItem.IsRight &&
                                                                    singleItem.RankNum ===
                                                                        3
                                                            "
                                                        >
                                                            <div>C</div>
                                                        </div>
                                                        <div
                                                            class=""
                                                            v-else-if="
                                                                singleItem.IsRight &&
                                                                    singleItem.RankNum ===
                                                                        4
                                                            "
                                                        >
                                                            <div>D</div>
                                                        </div>
                                                        <div
                                                            class=""
                                                            v-else-if="
                                                                singleItem.IsRight &&
                                                                    singleItem.RankNum ===
                                                                        5
                                                            "
                                                        >
                                                            <div>E</div>
                                                        </div>
                                                        <div
                                                            class=""
                                                            v-else-if="
                                                                singleItem.IsRight &&
                                                                    singleItem.RankNum ===
                                                                        6
                                                            "
                                                        >
                                                            <div>F</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="your jf">
                                                    您的答案：
                                                    <div
                                                        class="c-F33737 font-size18"
                                                    >
                                                        {{
                                                            this.orginObj
                                                                .SubjectAnswer
                                                                ? joinStr(
                                                                    this
                                                                        .orginObj
                                                                        .SubjectAnswer
                                                                )
                                                                : ""
                                                        }}
                                                    </div>
                                                    <!-- <div v-else class="c-F33737 font-size18">正确</div> -->
                                                </div>
                                            </div>
                                            <div class="right">
                                                <!-- 纠错 -->
                                            </div>
                                        </div>
                                        <div class="parsing">
                                            <div class="tit jf">
                                                <div class="cyc"></div>
                                                <div class="text c-72777F">
                                                    解析
                                                </div>
                                            </div>
                                            <div>
                                                <div
                                                    class="text"
                                                    v-if="orginObj.Analysis"
                                                    v-html="orginObj.Analysis"
                                                ></div>
                                                <div v-else class="text">
                                                    暂无解析
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else class="notParsingBox"></div>
                                </div>
                            </div>
                            <!-- 填空题 -->
                            <div
                                class="fillBlank"
                                v-else-if="
                                    orginObj.SubjectType === 3 ||
                                        orginObj.SubjectType === '3'
                                "
                            >
                                <div
                                    class="fillBlankItem"
                                    v-for="(singleItem,
                                    index) in orginObj.AnswerList"
                                    :key="index"
                                >
                                    <div
                                        class="font-size14 c-333333 fillBlanktext"
                                    >
                                        填空{{ index + 1 }}
                                    </div>
                                    <div class="fillBlankField">
                                        <el-input
                                            v-if="orginObj.status === 0"
                                            resize="none"
                                            v-model="singleItem.rankStyle"
                                            @input="testFill"
                                            rows="1"
                                            autosize
                                            type="textarea"
                                            placeholder="请在此输入您的答案"
                                        ></el-input>
                                        <el-input
                                            v-else
                                            readonly
                                            v-model="singleItem.userAnswer"
                                            rows="1"
                                            autosize
                                            type="textarea"
                                            placeholder="答案"
                                        ></el-input>
                                    </div>
                                </div>
                                <div
                                    class="confrimBtn xy-center font-size16 cursor"
                                >
                                    <!-- 确定 -->
                                </div>
                                <div v-if="orginObj.status" class="parsingBox">
                                    <div class="showAnswerText xy-between">
                                        <div class="lfet jf">
                                            <div class="right ">
                                                <div
                                                    style="margin-bottom:20px;color:#00B37C"
                                                >
                                                    正确答案：
                                                </div>
                                                <div
                                                    v-for="(singleItem,
                                                    index) in orginObj.AnswerList"
                                                    :key="index"
                                                >
                                                    <div
                                                        v-html="singleItem.Content"
                                                    ></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="right">
                                            <!-- 纠错 -->
                                        </div>
                                    </div>
                                    <div class="parsing">
                                        <div class="tit jf">
                                            <div class="cyc"></div>
                                            <div class="text c-72777F">
                                                解析
                                            </div>
                                        </div>
                                        <div>
                                            <div
                                                class="text"
                                                v-if="orginObj.Analysis"
                                                v-html="orginObj.Analysis"
                                            ></div>
                                            <div v-else class="text">
                                                暂无解析
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- 判断题 -->
                            <div
                                class="judgeTopic "
                                v-else-if="orginObj.SubjectType === 4"
                            >
                                <div class="topics">
                                    <div
                                        class="topicItem jf cursor"
                                        v-for="(singleItem,
                                        index) in orginObj.AnswerList"
                                        :key="index"
                                        @click="
                                            selectSingleAnswer(
                                                singleItem,
                                                orginObj.AnswerList
                                            )
                                        "
                                    >
                                        <div
                                            class="options xy-center cursor multiple "
                                            :class="{
                                                singleActive:
                                                    singleItem.rankStyle,
                                                makeRightStyle:
                                                    singleItem.origlRight,
                                                isErrorActive:
                                                    singleItem.userIsErrStyle
                                            }"
                                        >
                                            <div class="test">
                                                <div
                                                    v-if="
                                                        singleItem.RankNum === 1
                                                    "
                                                    class=""
                                                >
                                                    A
                                                </div>
                                                <div
                                                    v-else-if="
                                                        singleItem.RankNum === 2
                                                    "
                                                    class=""
                                                >
                                                    B
                                                </div>
                                                <div
                                                    v-else-if="
                                                        singleItem.RankNum === 3
                                                    "
                                                    class=""
                                                >
                                                    C
                                                </div>
                                                <div
                                                    v-else-if="
                                                        singleItem.RankNum === 4
                                                    "
                                                    class=""
                                                >
                                                    D
                                                </div>
                                                <div
                                                    v-else-if="
                                                        singleItem.RankNum === 5
                                                    "
                                                    class=""
                                                >
                                                    E
                                                </div>
                                                <div
                                                    v-else-if="
                                                        singleItem.RankNum === 6
                                                    "
                                                    class=""
                                                >
                                                    F
                                                </div>
                                                <div v-else class="">G</div>
                                            </div>
                                        </div>
                                        <div
                                            class="content  font-size14"
                                            v-html="singleItem.Content"
                                        ></div>
                                    </div>
                                </div>
                                <div>
                                    <div
                                        v-if="orginObj.status"
                                        class="parsingBox"
                                    >
                                        <div class="showAnswerText xy-between">
                                            <div class="lfet jf">
                                                <div class="right jf">
                                                    正确答案：
                                                    <div
                                                        class="c-00B37C font-size18"
                                                        v-for="(singleItem,
                                                        index) in orginObj.AnswerList"
                                                        :key="index"
                                                    >
                                                        <div
                                                            class=""
                                                            v-if="
                                                                singleItem.IsRight &&
                                                                    singleItem.RankNum ===
                                                                        1
                                                            "
                                                        >
                                                            <div>正确</div>
                                                        </div>
                                                        <div
                                                            class=""
                                                            v-else-if="
                                                                singleItem.IsRight &&
                                                                    singleItem.RankNum ===
                                                                        2
                                                            "
                                                        >
                                                            <div>错误</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="your jf">
                                                    您的答案：
                                                    <div
                                                        class="c-F33737 font-size18"
                                                    >
                                                        {{
                                                            this.orginObj
                                                                .SubjectAnswer
                                                                ? joinStr(
                                                                    this
                                                                        .orginObj
                                                                        .SubjectAnswer
                                                                )
                                                                : ""
                                                        }}
                                                    </div>
                                                    <!-- <div v-else class="c-F33737 font-size18">正确</div> -->
                                                </div>
                                            </div>
                                            <div class="right">
                                                <!-- 纠错 -->
                                            </div>
                                        </div>
                                        <div class="parsing">
                                            <div class="tit jf">
                                                <div class="cyc"></div>
                                                <div class="text c-72777F">
                                                    解析
                                                </div>
                                            </div>
                                            <div>
                                                <div
                                                    class="text"
                                                    v-if="orginObj.Analysis"
                                                    v-html="orginObj.Analysis"
                                                ></div>
                                                <div v-else class="text">
                                                    暂无解析
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else class="notParsingBox"></div>
                                </div>
                            </div>
                            <!-- 简答题 -->
                            <div
                                class="fillBlank"
                                v-else-if="
                                    orginObj.SubjectType === 5 ||
                                        orginObj.SubjectType === '5'
                                "
                            >
                                <div
                                    class="fillBlankItem"
                                    v-for="(singleItem,
                                    index) in orginObj.AnswerList"
                                    :key="index"
                                >
                                    <div
                                        class="font-size14 c-333333 fillBlanktext"
                                    ></div>
                                    <div class="fillBlankField">
                                        <el-input
                                            v-if="orginObj.status === 0"
                                            resize="none"
                                            v-model="singleItem.rankStyle"
                                            @input="testFill"
                                            rows="1"
                                            autosize
                                            type="textarea"
                                            placeholder="请在此输入您的答案"
                                        ></el-input>
                                        <el-input
                                            v-else
                                            readonly
                                            v-model="singleItem.userAnswer"
                                            rows="1"
                                            autosize
                                            type="textarea"
                                            placeholder="答案"
                                        ></el-input>
                                    </div>
                                </div>
                                <div
                                    class="confrimBtn xy-center font-size16 cursor"
                                >
                                    <!-- 确定 -->
                                </div>
                                <div v-if="orginObj.status" class="parsingBox">
                                    <div class="showAnswerText xy-between">
                                        <div class="lfet jf">
                                            <div class="right ">
                                                <div
                                                    style="margin-bottom:20px;color:#00B37C"
                                                >
                                                    正确答案：
                                                </div>
                                                <div
                                                    v-for="(singleItem,
                                                    index) in orginObj.AnswerList"
                                                    :key="index"
                                                >
                                                    <div
                                                        v-html="singleItem.Content"
                                                    ></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="right">
                                            <!-- 纠错 -->
                                        </div>
                                    </div>
                                    <div class="parsing">
                                        <div class="tit jf">
                                            <div class="cyc"></div>
                                            <div class="text c-72777F">
                                                解析
                                            </div>
                                        </div>
                                        <div>
                                            <div
                                                class="text"
                                                v-if="orginObj.Analysis"
                                                v-html="orginObj.Analysis"
                                            ></div>
                                            <div v-else class="text">
                                                暂无解析
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="bottom xy-between">
                        <div class="left jf">
                            <div
                                class="btn xy-center cursor font-size16"
                                @click="preTopic"
                            >
                                上一题
                            </div>
                            <div
                                class="btn xy-center next cursor font-size16"
                                @click="nextTopic"
                            >
                                下一题
                            </div>
                        </div>
                        <div class="rightSave" @click="cofrimFill">
                            <div class="save xy-center">
                                <div>
                                    <i class="el-icon-bank-card"></i>
                                    <span>提交此题</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 做题 -->
            </div>
            <div class="rightSheet">
                <sheet-card
                    ref="sheetCard"
                    :topic-list="dataList"
                    :err-list="isErrorList"
                    @jumoTopic="jumpSheet"
                    @reMakeTopic="againMake"
                    :serial-number="currentOrder + 1"
                ></sheet-card>
            </div>
        </div>
    </div>
</template>

<script>
import {
    GetMedicalQueationDetailByClassId,
    AddQuestionLog,
    MyCollection,
    MyCancelCollection,
    getDoctorTopicDetail
} from "@/api/course";
import SheetCard from "@/components/sheetCardSchool";
import { SourceType } from "@/kernel";

export default {
    props: {
        topicInfo: {
            type: Object,
            default: () => {
            }
        }
    },
    components: {
        SheetCard
    },
    data() {
        return {
            orginObj: {},
            dataList: [],
            passColumName: "",
            chapterList: [],
            fillAnswer: "",
            yourAnswer: "",
            currentOrder: 0,
            allTopicNum: 0,
            currentTopicId: "",
            currentAnswer: "",
            isErrorList: [],
            outputValue: "",
            Initialize: []
        };
    },
    computed: {},
    watch: {},
    created() {
        if (this.topicInfo && this.topicInfo.info) {
            this.topicInfo.info.forEach((v, i) => {
                let obj = {};
                obj.id = v.SubjectId;
                obj.isSubmit = false;
                this.Initialize.push(obj);
            });
        }
        this.dataList = this.topicInfo.info;
        this.dataList.forEach((v) => {
            v.status = 0;
        });
        this.currentTopicId = this.topicInfo.currentTopic.SubjectId;
        this.passColumName = `<p>${this.topicInfo.currentTopic.ClassName} </p>`;
        this.getCurrentOrder();
        this.getDoctorTopicDetail();
    },
    methods: {
        backRouter() {
            this.$router.back();
        },
        // 查看答案
        joinStr(val) {
            let arr = JSON.parse(val);
            let str = arr.join("");
            return str;
        },
        // 显示用户答案
        collection() {
            if (this.orginObj.collect === 0) {
                this.MyCollection().then(res => {
                    this.$message({
                        type: "success",
                        message: "收藏成功"
                    });
                    this.orginObj.collect = 1;
                })
            } else if (this.orginObj.collect === 1) {
                this.MyCollection().then(res => {
                    this.$message({
                        type: "warning",
                        message: "取消收藏"
                    });
                    this.orginObj.collect = 0;
                });
            }
        },
        async MyCollection() {
            try {
                let info = this.topicInfo.info[this.currentOrder]
                const { data } = await MyCollection({
                    id: this.orginObj.SubjectId,
                    name: this.orginObj.SubjectName,
                    sourceType: SourceType.organ,
                    type: 1,
                    score: 0,
                    SubjectType: this.orginObj.SubjectType,
                    categoryName: info.CategoryName || info.ClassName,
                    classId: info.CustomClassId,
                    categoryId: info.CategoryId,
                    columnId: ""
                });
                return Promise.resolve()
            } catch (error) {
                console.error(error)
                this.$toast("服务器繁忙，请稍后再试！");
                return Promise.reject()
            }
        },
        testFill(val) {
            this.outputValue = val;
        },
        // 获取当前题序号
        getCurrentOrder() {
            this.dataList.forEach((v, i) => {
                if (v.SubjectId === this.currentTopicId) {
                    this.currentOrder = i;
                }
            });
        },
        async getDoctorTopicDetail(id) {
            try {
                const { data } = await getDoctorTopicDetail({
                    queationId: id || this.currentTopicId,
                    sourceType: 2
                });
                data.data.status = 0;
                if (data.data.AnswerList) {
                    data.data.AnswerList.forEach((c) => {
                        c.rankStyle = null; // 点击选择的时候样式
                        c.userIsErrStyle = null; // 用户答错的样式
                        c.answerIsErr = false; // 当前选项是否答对
                        c.origlRight = false; // 原始状态是对的选项
                    });
                }
                let obj = data.data;
                let routPass = this.$route.query.from;
                this.Initialize.forEach((a) => {
                    if (a.id === obj.SubjectId) {
                        if (!a.isSubmit) {
                            obj.status = 0;
                            obj.SubjectAnswer = "";
                            obj.IsError = null;
                        } else {
                            obj.status = 1;
                        }
                    }
                });
                if (
                    obj.SubjectType === 1 ||
                    obj.SubjectType === 2 ||
                    obj.SubjectType === 4
                ) {
                    if (obj.AnswerList && obj.status) {
                        obj.showAnwser = true;
                        obj.AnswerList.forEach((c) => {
                            if (c.IsRight === 1) {
                                c.origlRight = 1;
                            }
                            obj.numArr = [];
                            let SubjectAnswer = JSON.parse(obj.SubjectAnswer);
                            SubjectAnswer.forEach((s) => {
                                if (s === "A") {
                                    obj.numArr.push(1);
                                }
                                if (s === "B") {
                                    obj.numArr.push(2);
                                }
                                if (s === "C") {
                                    obj.numArr.push(3);
                                }
                                if (s === "D") {
                                    obj.numArr.push(4);
                                }
                                if (s === "E") {
                                    obj.numArr.push(5);
                                }
                                if (s === "F") {
                                    obj.numArr.push(6);
                                }
                            });
                            if (
                                obj.numArr.includes(c.RankNum) &&
                                c.IsRight === 0
                            ) {
                                c.userIsErrStyle = 1;
                            }
                        });
                    }
                } else if (obj.SubjectType === 3) {
                    if (
                        obj.SubjectAnswer &&
                        obj.SubjectAnswer.indexOf(",") !== -1
                    ) {
                        obj.SubjectAnswer = obj.SubjectAnswer.split(",");
                        obj.AnswerList.forEach((a, i) => {
                            a.userAnswer = obj.SubjectAnswer[i];
                        });
                    } else {
                        obj.AnswerList.forEach((a, i) => {
                            a.userAnswer = obj.SubjectAnswer;
                        });
                    }
                } else {
                    obj.AnswerList.forEach((a, i) => {
                        a.userAnswer = obj.SubjectAnswer;
                    });
                }
                this.orginObj = obj;
                // 当前题序号
                if (this.dataList && this.dataList.length) {
                    this.allTopicNum = this.dataList.length;
                }
                return obj
            } catch (err) {
                console.log(err);
                this.$message("服务器繁忙，请稍后再试！");
            }
        },
        // 单选 和判断
        selectSingleAnswer(val, arr) {
            if (this.orginObj.status === 1) {
                return;
            }
            this.orginObj.haveDo = false;
            arr.forEach((v) => {
                if (v.AnswerId === val.AnswerId) {
                    v.rankStyle = 1;
                    this.orginObj.haveDo = true;
                } else {
                    v.rankStyle = 0;
                }
            });
            this.$forceUpdate();
        },
        // 多选
        selectSomeAnswer(val, arr) {
            if (this.orginObj.status === 1) {
                return;
            }
            if (val.rankStyle) {
                val.rankStyle = 0;
            } else {
                val.rankStyle = 1;
            }
            this.orginObj.haveDo = false;
            if (this.orginObj && this.orginObj.AnswerList) {
                this.orginObj.AnswerList.forEach((v) => {
                    if (v.rankStyle) {
                        this.orginObj.haveDo = true;
                        return;
                    }
                });
            }
            this.$forceUpdate();
        },
        againMake() {
            this.Initialize.forEach((a) => {
                a.isSubmit = false;
            });
        },
        //  答题卡跳转
        jumpSheet(val) {
            this.currentOrder = val.order - 1;
            this.currentTopicId = this.dataList[val.order - 1].SubjectId;
            this.passColumName = val.ClassName;
            this.getDoctorTopicDetail();
        },
        preTopic() {
            if (
                this.orginObj.SubjectType === 3 ||
                this.orginObj.SubjectType === 5
            ) {
                if (this.fillAnswer) {
                    this.$message("您还未提交答案");
                    return;
                }
            }
            if (!this.currentOrder) {
                this.$message("已到第一题");
                return;
            } else {
                this.currentOrder--;
                this.passColumName = this.dataList[this.currentOrder].ClassName;
                this.getDoctorTopicDetail(
                    this.dataList[this.currentOrder].SubjectId
                );
            }
        },
        nextTopic() {
            console.log(this.outputValue, "value");
            if (this.currentOrder === this.dataList.length - 1) {
                this.$message("已到最后一题");
                return;
            } else {
                this.currentOrder++;
                this.passColumName = this.topicInfo.info[this.currentOrder].ClassName;
                this.getDoctorTopicDetail(
                    this.dataList[this.currentOrder].SubjectId
                );
            }
        },
        cofrimFill() {
            if (this.orginObj.status) {
                this.$message("请勿重复提交");
                return;
            } else {
                this.subMitAnswer();
            }
        },
        objOfPropertyToArr(object) {
            var arr = [];
            var i = 0;
            for (var item in object) {
                arr[i] = item;
                i++;
            }
            return arr;
        },
        currentSumitAnswer(arr) {
            return arr;
        },
        // 提交答案
        async subMitAnswer() {
            let userSelectAnswer = [];
            let v = this.orginObj;
            const subjectType = parseInt(v.SubjectType)
            if (
                subjectType === 1 ||
                subjectType === 2 ||
                subjectType === 4
            ) {
                if (!this.orginObj.haveDo) {
                    this.$message("请作答");
                    return;
                }
            } else if (subjectType === 3 || subjectType === 5) {
                if (!this.outputValue) {
                    this.$message("请作答");
                    return;
                }
            }
            if (
                v.SubjectType === 1 ||
                v.SubjectType === 2 ||
                v.SubjectType === 4
            ) {
                if (v.AnswerList) {
                    v.AnswerList.forEach((c) => {
                        if (c.rankStyle) {
                            userSelectAnswer.push(c.RankNum);
                        }
                        if (c.IsRight) {
                            c.origlRight = 1;
                        }
                        if (c.rankStyle && !c.IsRight) {
                            c.userIsErrStyle = 1;
                            // 当前答案错误
                            c.answerIsErr = true;
                        }
                        if (!c.rankStyle && c.IsRight) {
                            c.answerIsErr = true;
                        }
                    });
                    try {
                        v.AnswerList.forEach((c) => {
                            if (c.answerIsErr) {
                                v.isErr = 1;
                                throw Error();
                            } else {
                                v.isErr = 0;
                            }
                        });
                    } catch (error) {
                        console.log(error);
                    }
                }
                let answers = [];
                userSelectAnswer.forEach((v) => {
                    if (v === 1) {
                        answers.push("A");
                    }
                    if (v === 2) {
                        answers.push("B");
                    }
                    if (v === 3) {
                        answers.push("C");
                    }
                    if (v === 4) {
                        answers.push("D");
                    }
                    if (v === 5) {
                        answers.push("E");
                    }
                    if (v === 6) {
                        answers.push("F");
                    }
                    if (v === 7) {
                        answers.push("G");
                    }
                });
                this.orginObj.SubjectAnswer = JSON.stringify(answers);
            }
            if (v.SubjectType === 3 || v.SubjectType === 5) {
                v.status = 1;
                let answerStr = [];
                v.AnswerList.forEach((a) => {
                    answerStr.push(a.rankStyle);
                });
                this.orginObj.SubjectAnswer = answerStr.join(",");
            }

            // 提交后  答案回显
            let obj = this.orginObj;
            if (obj.SubjectType === 3) {
                if (
                    obj.SubjectAnswer &&
                    obj.SubjectAnswer.indexOf(",") !== -1
                ) {
                    obj.SubjectAnswer = obj.SubjectAnswer.split(",");
                    obj.AnswerList.forEach((a, i) => {
                        a.userAnswer = obj.SubjectAnswer[i];
                    });
                    this.orginObj.SubjectAnswer = this.orginObj.SubjectAnswer.join(
                        ","
                    );
                } else {
                    obj.AnswerList.forEach((a, i) => {
                        a.userAnswer = obj.SubjectAnswer;
                    });
                }
            } else if (obj.SubjectType === 5) {
                obj.AnswerList.forEach((a, i) => {
                    a.userAnswer = obj.SubjectAnswer;
                });
            }

            this.$forceUpdate();
            let reg = /<\/?.+?\/?>/g;
            try {
                const { data } = await AddQuestionLog({
                    id: this.orginObj.SubjectId,
                    name: this.orginObj.SubjectName,
                    sourceType: 2,
                    SubjectAnswer: this.orginObj.SubjectAnswer,
                    dataType: 3,
                    categoryName: this.passColumName.replace(reg, ""),
                    SubjectType: this.orginObj.SubjectType,
                    classId: this.orginObj.ClassId,
                    chapterIdList: this.orginObj.ClassId,
                    isError: this.orginObj.isErr,
                    categoryId: this.orginObj.SubjectId
                });
                this.dataList.forEach((v, i) => {
                    if (v.SubjectId === this.orginObj.SubjectId) {
                        let obj = {};
                        if (this.orginObj.isErr) {
                            obj.id = this.orginObj.SubjectId;
                            obj.iserror = "True";
                            obj.status = 1;
                            this.isErrorList.push(obj);
                        } else {
                            obj.id = this.orginObj.SubjectId;
                            obj.iserror = "False";
                            obj.status = 1;
                            this.isErrorList.push(obj);
                        }
                    }
                });
                this.orginObj.status = 1;
                this.Initialize.forEach((a) => {
                    if (a.id === this.orginObj.SubjectId) {
                        if (!a.isSubmit) {
                            a.isSubmit = true;
                        }
                    }
                });
                this.$forceUpdate();
                this.outputValue = ""
            } catch (err) {
                this.$toast("服务器繁忙，请稍后再试！");
            }
        }
    }
};
</script>

<style scoped lang="less">
.contain {
    ::v-deep img {
        max-width: 100%;
    }

    box-sizing: border-box;

    .back {
        margin-top: 10px;
    }

    .box {
        margin-top: 20px;
        display: flex;
        justify-content: space-between;

        .left {
            background: #ffffff;
            border-radius: 12px;
            width: 850px;

            .nav {
                border-bottom: 1px solid #f1f2f6;
                height: 70px;
                padding: 20px;
                box-sizing: border-box;

                .tit {
                    ::v-deep p {
                        font-size: 14px;
                    }
                }

                .back {
                    margin: 0;
                }

                .throw {
                    width: 1px;
                    height: 18px;
                    background-color: #dcdfe6;
                    margin: 0 15px;
                }
            }

            .twoBox {
                .topicContain {
                    padding: 30px;
                    box-sizing: border-box;
                    min-height: 620px;

                    .topicNav {
                        display: flex;
                        justify-content: space-between;

                        .tit {
                            display: flex;

                            .topicType {
                                flex-shrink: 0;
                                margin-right: 13px;
                            }

                            .topicContent {
                                width: 680px;
                            }
                        }
                    }

                    .allTopics {
                        .topics {
                            margin-top: 32px;
                            margin-left: 60px;

                            .topicItem {
                                margin-bottom: 20px;
                                font-size: 14px;

                                .options {
                                    width: 30px;
                                    height: 30px;
                                    border-radius: 50%;
                                    background: #ffffff;
                                    border: 1px solid #e5e8ec;
                                    margin-right: 10px;
                                }

                                .singleActive {
                                    background-color: #256cf4;
                                    color: white;
                                }

                                .makeRightStyle {
                                    background-color: #00b37c;
                                    color: white;
                                }

                                .isErrorActive {
                                    background-color: #f7593b;
                                    color: white;
                                }

                                .multiple {
                                    border-radius: 6px;
                                }
                            }
                        }

                        .parsingBox {
                            width: 100%;
                            border-radius: 8px;
                            border: 1px solid #e5e8ec;
                            min-height: 100px;
                            padding: 30px;
                            box-sizing: border-box;
                            font-size: 14px;

                            .showAnswerText {
                                .lfet {
                                    .your {
                                        margin-left: 70px;
                                    }
                                }
                            }

                            .parsing {
                                .tit {
                                    margin: 30px 0 20px 0;

                                    .cyc {
                                        width: 5px;
                                        height: 5px;
                                        border-radius: 50%;
                                        background: #256cf4;
                                        margin-right: 8px;
                                    }
                                }
                            }
                        }

                        .notParsingBox {
                            width: 100%;
                            border-radius: 8px;
                            // min-height: 218px;
                        }

                        .fillBlank {
                            .fillBlankItem {
                                .fillBlanktext {
                                    margin: 30px 0 20px 0;
                                }

                                ::v-deep .el-textarea__inner {
                                    min-height: 100px !important;
                                }
                            }

                            .confrimBtn {
                                // width: 120px;
                                // height: 40px;
                                // background: #EEF4FF;
                                // border-radius: 8px;
                                // border: 1px solid #256CF4;
                                // color: #256CF4;
                                margin: 40px 0;
                            }
                        }
                    }
                }

                .bottom {
                    padding: 25px 40px;
                    box-sizing: border-box;
                    width: 100%;
                    height: 100px;
                    box-shadow: 0px 2px 20px 0px rgba(229, 232, 236, 0.65);

                    .left {
                        .btn {
                            width: 140px;
                            height: 48px;
                            background: #edf1f5;
                            border-radius: 8px;
                        }

                        .next {
                            margin-left: 30px;
                        }
                    }

                    .rightSave {
                        .save {
                            width: 180px;
                            height: 48px;
                            background: #eff5ff;
                            border-radius: 8px;
                            border: 1px solid #256cf4;
                            font-size: 14px;
                            color: #256cf4;
                        }

                        span {
                            margin-left: 5px;
                        }
                    }
                }
            }
        }

        .rightSheet {
            width: 320px;
            min-height: 790px;
            background: #ffffff;
            border-radius: 12px;
        }
    }
}
</style>
